import React from "react";
import { FormattedMessage } from "react-intl";
import { AccordionSection } from "./AccordionSection";
export function ListSection(_a) {
    var id = _a.id, labelId = _a.labelId, items = _a.items, renderItem = _a.renderItem, noItemsMessageId = _a.noItemsMessageId, open = _a.open, onToggle = _a.onToggle;
    return (React.createElement(AccordionSection, { id: id, labelId: labelId, open: open, onToggle: onToggle }, items.length > 0 ? (items.map(renderItem)) : (React.createElement("p", null,
        React.createElement(FormattedMessage, { id: noItemsMessageId })))));
}
